import { isPreferenceSectionId } from '../features/preferences/preferenceSectionIds';

/** Push-or-replace decision for the controller's address sync. A new history entry is only worth making
 *  when the address changes: handlers such as handleSelectClient push the entry themselves, and the sync
 *  that follows would otherwise stack copies of the same address that Back then walks through. */
export function decideHistoryWrite(opts: {
  currentUrl: string;
  nextUrl: string;
  replaceRequested: boolean;
}): 'push' | 'replace' {
  return opts.replaceRequested || opts.currentUrl === opts.nextUrl ? 'replace' : 'push';
}

/** On desktop, a bare /preferences only exists for an instant: the view settles on its first section. That
 *  settle must overwrite the bare entry, otherwise Back lands on /preferences and settles forward again.
 *  An address naming a section that does not exist is the same dead end, so it settles by replacing too. */
export function isPreferencesSettle(
  currentState: { view?: string; preferencesSection?: string | null } | null | undefined,
  currentView: string,
  nextSection: string | null,
  isDesktop: boolean,
  currentPathname?: string,
): boolean {
  if (!isDesktop || currentView !== 'preferences' || !nextSection) return false;
  if (namesUnknownPreferencesSection(currentPathname)) return true;
  return currentState?.view === 'preferences' && !currentState.preferencesSection;
}

function namesUnknownPreferencesSection(pathname: string | undefined): boolean {
  const named = pathname?.replace(/\/+$/, '').match(/^\/preferences\/([^/]+)$/)?.[1];
  return !!named && !isPreferenceSectionId(decodeURIComponent(named));
}
